import { currecyFormat } from '@/mixins/currency'
import hexToRgba from 'hex-to-rgba'

let chart = null
let legendItems = null
const legendItemSelector = '.legend-item'
const legendLabelSeletor = '.label'

export let legendItemsRefs = null

/**
 * Bind custom events for chart.
 *
 * @param {object} myChart chart object
 * @param {object} containerElement
 */
export const bindChartEvents = (myChart, containerElement) => {
  chart = myChart
  legendItems = [...containerElement.querySelectorAll(legendItemSelector)]

  /** Add event listeners for legends. Returns mapped array with remove listeners function */
  legendItemsRefs = getLegendItemsRefs(legendItems)

  /** Set initial active state legend background color */
  legendItems.forEach((legendEl, index) => toggleLegendBckgroundColor(index, legendEl))
}

/**
 * Add event listeners for legends
 * Returns mapped array with remove listeners function
 *
 * For remove listeners use legendItemsRefs.forEach((f) => f())
 *
 * @param {legendItems} legendItems
 * @returns mapped array with remove listeners function
 */
const getLegendItemsRefs = (legendItems) =>
  legendItems.map((legend, i) => {
    /** Add click event listeners */
    const listener = () => updateDataset(legend, i)
    legend.addEventListener('click', listener)

    /**
     * Function for remove listener
     * ex. legendItemsRefs.forEach((f) => f())
     * */
    return () => legend.removeEventListener('click', listener)
  })

/**
 * Update chart after turn active state dateset
 *
 * @param {DOMNode} currentLegendEl Legend DOMNode
 * @param {Number} index currentLegendEl index
 */
const updateDataset = (currentLegendEl, index) => {
  const meta = chart.getDatasetMeta(index)
  const legendEl = currentLegendEl.querySelector(legendLabelSeletor).parentNode

  /** Turn active state dataset */
  meta.hidden = !meta.hidden

  /** Set legend background color */
  toggleLegendBckgroundColor(index, legendEl)

  chart.update()
}

export const legendItemData = (dataset) => {
  const label = dataset.label
  const bgColor = dataset.backgroundColor
  const total = dataset.summary

  const formattedTotal = currecyFormat(total, { style: 'currency' })

  return {
    label,
    bgColor,
    total,
    formattedTotal,
  }
}

/**
 * Generete custom legend template
 *
 * @returns void set html string template for legend
 */

const legendCallback = (chart) => {
  const labels = chart.data.datasets.map((dataset, i) => {
    const { bgColor, label, formattedTotal } = legendItemData(dataset)

    return `
      <div id="legend-${i}-item" class="legend-item" data-background="${bgColor}">
        <div class="legend-circle" style="background: ${bgColor}"></div>
        <div class="label">${label}: <span class="total">${formattedTotal}</span> </div>
      </div>
    `
  })

  return labels.join('')
}

/**
 * Set active legend backgdrond
 *
 * @param {object} Label legend object
 * @param {color} color color to set for legend label
 */
function setLegendBackgroundColor(legendEl, color) {
  legendEl.style['background-color'] = hexToRgba(color, 0.2)
}

function toggleLegendBckgroundColor(index, legendEl) {
  const meta = chart.getDatasetMeta(index)

  meta.hidden
    ? setLegendBackgroundColor(legendEl, '#ffffff')
    : setLegendBackgroundColor(legendEl, getDatasetBgColor(legendEl))
}

/**
 * Returns hex background value of label dataset
 *
 * @param {object} label Label legend object
 * @returns value hex background value of label dataset
 */
function getDatasetBgColor(legend) {
  return legend.dataset.background
}

/**
 * Sets initial hidden dataset state.
 * Get hidden state value from source dataset and set to chart meta dataset.
 *
 * @returns updated hidden dataset state.
 */
export const setInitialHiddenState = () => {
  if (!chart || !legendItems.length) return

  legendItems.forEach((item, index) => {
    const initialHidden = chart.data.datasets[index].hidden ?? true
    const meta = chart.getDatasetMeta(index)
    const legendEl = item.querySelector(legendLabelSeletor).parentNode

    meta.hidden = initialHidden
    toggleLegendBckgroundColor(index, legendEl)
  })

  chart.update()
}

export const barLegendOptions = {
  legend: false, // Hide chart.js legend
  legendCallback,
}
